import gql from 'graphql-tag';

export default jobScheduleId => {
  const resetSubsequentJobsFromErrorJob = `resetSubsequentJobsFromErrorJob(jobScheduleId: "${jobScheduleId}")`;
  return gql`
  mutation {
    ${resetSubsequentJobsFromErrorJob}
  }
`;
};